import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.scss'],
})
export class AccountNavComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
